module.exports = __webpack_public_path__ + "2b1300ca103f4de2276b267f2184debc.jpg";